import { render, staticRenderFns } from "./BaseTableLite.vue?vue&type=template&id=ec10ac0e&"
import script from "./BaseTableLite.vue?vue&type=script&lang=js&"
export * from "./BaseTableLite.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableLite.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports